import { render } from "./progress-checkpoint-bar.vue?vue&type=template&id=2ed2298c"
import script from "./progress-checkpoint-bar.vue?vue&type=script&lang=js"
export * from "./progress-checkpoint-bar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__